import { useEffect, useRef, useState } from "react";
import "./index.less";
import { Calibration, CalibrationItem, ParamPicture, RectifyPicture } from "@/global/interface/calibration";
import { useParams } from "react-router-dom";
import { addCalibration, calibrationFixPosition, deleteCalibrationItem, generateCalibrationResult, getCalibration, getCalibrationItemImage, getParamPictureDetail, getParamPictureList, getRectifyPictureListByParamId, takeCalibrationPhoto } from "@/api/monitor-object/calibration";
import { Button, Form, Input, Modal, Spin, Tooltip, message } from "antd";
import { CameraOutlined, DeleteOutlined, BorderHorizontalOutlined, CaretRightOutlined } from "@ant-design/icons"
import { getImageStr, getMonitorParamListByParamId, sendMsgToAiServer } from "@/api/device/sensor";
import classNames from "classnames";
import { Image } from "antd";
import TnModal from "@/global/components/base-modal";
import TnMessage from "@/global/components/message";
import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";
import axios from "axios";
import ImgCanvasRange, { RectCoord } from "@/global/components/img-canvas-range";


interface CalibrationProps {

}


export function CalibrationPanel(props: CalibrationProps) {
    const { monitorParameterId, projectId } = useParams();

    const [calibration, setCalibration] = useState<Calibration>(null);
    const [selectCalibrationItem, setSelectCalibrationItem] = useState<CalibrationItem>(null);

    const selectCalibrationItemRef = useRef<string>(null);


    const [base64ImgLeft, setBase64ImgLeft] = useState<string>(null);
    const [base64ImgRight, setBase64ImgRight] = useState<string>(null);

    const [isPosCalibration, setIsPosCalibration] = useState<boolean>(false)
    const [pageIndex, setPageIndex] = useState<number>(1)
    const [paramPictureList, setParamPictureList] = useState<ParamPicture[]>([])
    const [selectParamPictureItem, setSelectParamPictureItem] = useState<ParamPicture>(null)
    const [form] = Form.useForm();

    // 范围标定变量
    const [leftCoord, setLeftCoord] = useState<RectCoord>({ bottomRight: { x: 2560, y: 1440 }, topLeft: { x: 0, y: 0 } })
    const [rightCoord, setRightCoord] = useState<RectCoord>({ bottomRight: { x: 2560, y: 1440 }, topLeft: { x: 0, y: 0 } })
    const [leftImage, setLeftImage] = useState<string>()
    const [rightImage, setRightImage] = useState<string>()
    const [fileName, setFileName] = useState<string>()

    useEffect(() => {
        generateData();
        let timer$ = setInterval(() => {
            generateData();
        }, 5000)
        return (() => {
            clearInterval(timer$);
        })
    }, [monitorParameterId])

    const generateData = (forceUpdate: boolean = false) => {
        if (monitorParameterId != null) {
            //根据monitorParameterId获取标定信息
            getCalibration(+monitorParameterId).then(res => {
                if (res.status === 200) {
                    if (res.data) {//如果存在
                        setCalibration(res.data);
                        if (res.data.items && res.data.items.length > 0) {
                            if (forceUpdate || selectCalibrationItemRef.current == null) {
                                handleItemClick(res.data.items[0]);
                            }
                        }
                    } else { // 如果不存在，则创建一个新的
                        addCalibration(+monitorParameterId).then(res => {
                            if (res.status === 200) {
                                if (res.data) {
                                    setCalibration(res.data);
                                }
                            }
                        });
                    }
                }
            })
        }
    }


    /**
     * 拍摄标定的回调
     */
    const onClickTakePhoto = () => {
        // let sendData = {};
        // sendData["type"] = "calibration-picture";
        // sendData["param_id"] = monitorParameterId;
        // sendMsgToAiServer(+projectId, sendData)
        takeCalibrationPhoto(+monitorParameterId).then(res => {
            console.log('res', res)
        })
    }

    /**
     * 删除图片的回调
     */
    const onClickDelete = () => {
        if (selectCalibrationItem == null) {
            return;
        }
        // let sendData = {};
        // sendData["type"] = "calibration-picture-delete";
        // sendData["param_id"] = monitorParameterId;
        // sendData["num"] = selectCalibrationItem.num;
        // sendMsgToAiServer(+projectId, sendData);
        deleteCalibrationItem(selectCalibrationItem.uuid).then(res => {
            if (res.status === 200) {
                generateData(true);
                TnMessage.success("删除成功");
            }
        });
    }

    /**
     * 生成标定结果
     */
    const onClickGenerateCalibrationResult = () => {
        if (selectCalibrationItem == null) {
            return;
        }
        let sendData = {};
        // sendData["type"] = "generate-calibration-result";
        // sendData["param_id"] = monitorParameterId;
        // sendData["num"] = selectCalibrationItem.num;
        // sendMsgToAiServer(+projectId, sendData);
        generateCalibrationResult(+monitorParameterId).then(res => {
            console.log('res', res)
        })
    }

    /**
     * 固定相机的回调（存储经纬度以及缩放系数）
     */
    const onClickFixPosition = () => {
        TnModal().baseModal({
            title: "记录经纬度",
            content: "记录经纬度会清空原有位置信息，可能导致您需要重新标定。请确认是否重新记录经纬度。",
            onOk() {
                calibrationFixPosition(+monitorParameterId).then((res) => {
                }).finally(() => {
                    Modal.destroyAll();
                })
            },
        })
    }

    const handleItemClick = (item: CalibrationItem) => {
        setSelectCalibrationItem(item);
        if (item != null && item.uuid != null) {
            selectCalibrationItemRef.current = item.uuid;
            getCalibrationItemImage(item.uuid).then(res => {
                if (res.status === 200) {
                    if (res.data.leftImageText) {
                        setBase64ImgLeft(res.data.leftImageText);
                    }
                    if (res.data.rightImageText) {
                        setBase64ImgRight(res.data.rightImageText);
                    }
                }
            });

        } else {
            selectCalibrationItemRef.current = null;
        }
    }

    const onShowPosPictureList = () => {
        setPageIndex(2)
        getParamPictureList(+monitorParameterId).then(res => {
            let list: ParamPicture[] = res.data || [];

            list.forEach(item => {
                item.fileName = item.fileName
                    .replace("processed_frame_", "")
                    .replace(".jpg", "")
                    .replace("_depth", "");

                // 提取最后的数字部分
                let match = item.fileName.match(/_(\d+)$/);
                let num = match ? Number(match[1]) : 0;
                item.num = num
            });
            // 按 num 进行排序
            let sortList = list.sort((a, b) => b.num - a.num);
            setParamPictureList(sortList);
        });
    }

    const submitPos = () => {
        let data = form.getFieldsValue()
        let a: number = data["a"]
        let b: number = data["b"]
        let c: number = data["c"]
        let d: number = data["d"]

        if (c * b - a * d == 0) {
            message.error("网格坐标 a*d ≠ b*c")
            return
        }

        let sendData = form.getFieldsValue()
        sendData["type"] = "count-param-vector"
        sendData["param_id"] = +monitorParameterId
        console.log('sendData', sendData)
        sendMsgToAiServer(+projectId, sendData)
    }

    const getRectifyCurrentPicture = () => {
        let sendData = {};


        sendData["type"] = "rectify-current-picture";
        sendData["param_id"] = monitorParameterId;
        sendMsgToAiServer(+projectId, sendData, "rectify", +monitorParameterId).then(res => {
            setLeftImage(null)
            setRightImage(null)
            startInterval()
        })
    }

    const startInterval = () => {
        let interval = setInterval(() => {
            getRectifyPictureListByParamId(+monitorParameterId).then(res => {
                let list: RectifyPicture[] = res.data
                if (list.length == 2) {
                    let left = list.find(i => i.pos == "LEFT")
                    if (left) {
                        setLeftImage(left.image)
                        setFileName(left.fileName)
                    }
                    let right = list.find(i => i.pos == "RIGHT")
                    if (right) {
                        setRightImage(right.image)
                        setFileName(right.fileName)
                    }
                    clearInterval(interval)
                }
            })
        }, 3000)
    }

    const confirmRange = () => {
        let sendData = {}
        if (!!!leftImage || !!!rightImage) {
            return
        }
        sendData["type"] = "generate-vector-picture"
        sendData["param_id"] = monitorParameterId;
        sendData["file_name"] = fileName
        sendData["left_max_x"] = leftCoord.bottomRight.x
        sendData["left_min_x"] = leftCoord.topLeft.x
        sendData["left_max_y"] = leftCoord.bottomRight.y
        sendData["left_min_y"] = leftCoord.topLeft.y

        sendData["right_max_x"] = rightCoord.bottomRight.x
        sendData["right_min_x"] = rightCoord.topLeft.x
        sendData["right_max_y"] = rightCoord.bottomRight.y
        sendData["right_min_y"] = rightCoord.topLeft.y
        sendMsgToAiServer(+projectId, sendData, "vector", +monitorParameterId)
    }

    return (
        <div className="calibration-panel-container">
            {/* 左侧 */}
            <div className="left">
                {pageIndex == 1 && (
                    <>
                        {/* 工具栏 */}
                        <div className="toolbar">
                            <Tooltip
                                title="拍摄">
                                <Button
                                    size="small"
                                    icon={<CameraOutlined />}
                                    onClick={onClickTakePhoto}
                                >
                                </Button>
                            </Tooltip>
                            <Tooltip
                                title="删除">
                                <Button
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    onClick={onClickDelete}
                                >
                                </Button>
                            </Tooltip>
                            <Tooltip
                                title="记录经纬度">
                                <Button
                                    size="small"
                                    icon={<BorderHorizontalOutlined />}
                                    onClick={onClickFixPosition}
                                >
                                </Button>
                            </Tooltip>

                            <Tooltip
                                title="生成标定结果">
                                <Button
                                    size="small"
                                    icon={<CaretRightOutlined />}
                                    onClick={onClickGenerateCalibrationResult}
                                >
                                </Button>
                            </Tooltip>
                            {/* <Tooltip title="指定标定范围">
                                <Button
                                    size="small"
                                    onClick={() => { startPickRange() }}
                                >R</Button>
                            </Tooltip>
                            <Tooltip title="标定向量">
                                <Button
                                    size="small"
                                    onClick={() => { onShowPosPictureList() }}
                                >V</Button>
                            </Tooltip> */}
                        </div>
                        {/* 列表 */}
                        <div className="list">
                            {(calibration?.items || []).map((item, index) => (
                                <div
                                    key={index}
                                    className={classNames({
                                        'list-item': true,
                                        'selected': selectCalibrationItem?.id == item.id
                                    })}

                                    onClick={() => handleItemClick(item)}
                                >
                                    列表项 {item.num}
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {pageIndex == 2 && (
                    <>
                        {/* <div className="toolbar">
                            <Tooltip title="标定图片">
                                <Button
                                    size="small"
                                    onClick={() => { setPageIndex(1) }}
                                >P</Button>
                            </Tooltip>
                            <Tooltip title="指定标定范围">
                                <Button
                                    size="small"
                                    onClick={() => { startPickRange() }}
                                >R</Button>
                            </Tooltip>
                        </div>
                        <div className="list">
                            {paramPictureList
                                ?.sort((a, b) => (a.fileName || "").localeCompare(b.fileName || ""))
                                .map(picture => (
                                    <div
                                        onClick={() => { showParamPictureItemDetail(picture.id) }}
                                        key={picture.id}
                                        className={classNames({
                                            "list-item": true,
                                            "selected": selectParamPictureItem?.id === picture.id
                                        })}
                                    >
                                        {picture?.fileName || "图片"}
                                    </div>
                                ))}
                        </div> */}
                    </>
                )}
                {pageIndex == 3 && (
                    <>
                        <div className="toolbar">
                            <Tooltip title="标定图片">
                                <Button
                                    size="small"
                                    onClick={() => { setPageIndex(1) }}
                                >P</Button>
                            </Tooltip>
                            <Tooltip title="标定向量">
                                <Button
                                    size="small"
                                    onClick={() => { onShowPosPictureList() }}
                                >V</Button>
                            </Tooltip>
                        </div>
                    </>
                )}
            </div>

            <div className="right">
                {pageIndex == 1 && (
                    <>
                        {/* 文字部分 */}
                        <div className="text-section">
                            <div style={{ fontSize: "20px" }}>标定结果：</div>
                            <div>{calibration?.resultStr ? calibration?.resultStr : ""}</div>
                            <div style={{ fontSize: "20px" }}>错误编号：</div>
                            <div>{(calibration?.fails && calibration?.fails.length > 0) ? calibration?.fails.join(", ") : "无"}</div>
                        </div>

                        {/* 图片部分 */}
                        <div className="image-section">
                            {base64ImgLeft && (
                                <Image
                                    src={`data:image/jpeg;base64,${base64ImgLeft}`}
                                    className="image"
                                />
                            )}
                            {base64ImgRight && (
                                <Image
                                    src={`data:image/jpeg;base64,${base64ImgRight}`}
                                    className="image"
                                />
                            )}
                        </div>
                    </>
                )}

                {pageIndex == 2 && (
                    <>
                        <div className="picture-area">
                            {selectParamPictureItem && (
                                <Spin spinning={!!!selectParamPictureItem?.image}>
                                    <Image
                                        src={`data:image/jpeg;base64,${selectParamPictureItem?.image}`}
                                        className="image"
                                    />
                                </Spin>
                            )}

                        </div>
                        <Form form={form} onFinish={submitPos}>

                            <div className="input-area">
                                <div className="area-title">
                                    第一个点
                                </div>
                                <div className="area-list">
                                    <div className="list-head">
                                        网格坐标
                                    </div>
                                    <Form.Item rules={[{ required: true }]} label="a:" name="a">
                                        <Input className="my-input" />
                                    </Form.Item>
                                    <Form.Item rules={[{ required: true }]} label="b:" name="b">
                                        <Input className="my-input" />
                                    </Form.Item>
                                </div>
                                <div className="area-list">
                                    <div className="list-head">
                                        实际坐标
                                    </div>
                                    <Form.Item rules={[{ required: true }]} label="x:" name="px1">
                                        <Input className="my-input" />
                                    </Form.Item>
                                    <Form.Item rules={[{ required: true }]} label="y:" name="py1">
                                        <Input className="my-input" />
                                    </Form.Item>
                                    <Form.Item rules={[{ required: true }]} label="z:" name="pz1">
                                        <Input className="my-input" />
                                    </Form.Item>
                                </div>
                                <div className="area-title">
                                    第二个点
                                </div>
                                <div className="area-list">
                                    <div className="list-head">
                                        网格坐标
                                    </div>
                                    <Form.Item rules={[{ required: true }]} label="c:" name="c">
                                        <Input className="my-input" />
                                    </Form.Item>
                                    <Form.Item rules={[{ required: true }]} label="d:" name="d">
                                        <Input className="my-input" />
                                    </Form.Item>
                                </div>
                                <div className="area-list">
                                    <div className="list-head">
                                        实际坐标
                                    </div>
                                    <Form.Item rules={[{ required: true }]} label="x:" name="px2">
                                        <Input className="my-input" />
                                    </Form.Item>
                                    <Form.Item rules={[{ required: true }]} label="y:" name="py2">
                                        <Input className="my-input" />
                                    </Form.Item>
                                    <Form.Item rules={[{ required: true }]} label="z:" name="pz2">
                                        <Input className="my-input" />
                                    </Form.Item>
                                </div>
                            </div>
                            <Button type="primary" htmlType="submit">
                                确认
                            </Button>
                        </Form>

                    </>
                )}

                {pageIndex == 3 && (
                    <>
                        <div className="pick-area">
                            <div className="pick-item">
                                <ImgCanvasRange
                                    base64String={leftImage}
                                    canvasHeight={300}
                                    canvasWidth={400}
                                    rectCoords={leftCoord}
                                    setRectCoords={setLeftCoord}
                                />
                            </div>
                            <div className="pick-item">
                                <ImgCanvasRange
                                    base64String={rightImage}
                                    canvasHeight={300}
                                    canvasWidth={400}
                                    rectCoords={rightCoord}
                                    setRectCoords={setRightCoord}
                                />
                            </div>
                        </div>
                        <Button type="default" style={{ width: 250, margin: "0px auto" }} onClick={getRectifyCurrentPicture}>
                            获取最新图片
                        </Button>
                        <Button type="primary" style={{ width: 250, margin: "0px auto" }} onClick={confirmRange}>
                            确认范围并进行标定
                        </Button>

                    </>
                )}

            </div>


        </div>
    );
};